
function SdOrdersController(TranslationService, StoreService) {
    var ctrl = this;

    ctrl.translation = TranslationService.getActiveTranslation();
    this.margin = '100';

    ctrl.prefs = {
        name: 'StoreOrdersGrid',
        selContact: null,
        sortByCol: null,
        canAdd: false,
        canEdit: true,
        canDelete: false,
    };

    ctrl.loadService = StoreService.getUserOrders;
    ctrl.loadColumns = StoreService.getUserOrdersColumns;    
    ctrl.resetService = StoreService.resetCache;

    ctrl.customClass = function (item) {
        return 'status-card Status' + item;
    };

    ctrl.sapIDClass = function (item) {
        return 'sap-order';
    };

    ctrl.updateTypeClass = function (item) {
        return 'sd-update-type ' + item;
    };

    ctrl.columns = [
        { name: 'OrderID', display: 'OrderID', orderBy: 'asc', width: 7.5, isKey: true, filterOptions: [] },
        { name: 'Subject', display: 'Assunto', width: 5 },
        { name: 'SapOrderID', display: 'SapOrderID', customClass: ctrl.sapIDClass, filterOptions: [], width: 7.5 },
        { name: 'StatusID', customClass: ctrl.customClass, display: 'StatusID', filterOptions: [], width: 5 },
        { name: 'UpdateType', display: 'Atualização', customClass: ctrl.updateTypeClass, filterOptions: [], width: 5 },
        { name: 'UpdateDate', display: 'Dt Atualiz', dataType: 'date', format: ctrl.translation.DatePickerFormat, filterOptions: [], width: 5 },
        { name: 'ContactName', display: ctrl.translation.Client, id: 'ContactID', filterOptions: [], width: 20 },
        { name: 'ReservationDate', display: 'Dt Reserva', dataType: 'date', format: ctrl.translation.DatePickerFormat, filterOptions: [], width: 5 },
        { name: 'ConfirmationDate', display: 'Dt Fechamento', dataType: 'date', format: ctrl.translation.DatePickerFormat, filterOptions: [], width: 5 },
        { name: 'SapPlantDate', display: 'Dt Pedido', dataType: 'date', format: ctrl.translation.DatePickerFormat, filterOptions: [], width: 5 },
        //{ name: 'DateMode', display: 'Datas', filterOptions: [], width: 5 },
        { name: 'TypeOfSystem', display: 'Sistema', filterOptions: [], width: 5 },
        { name: 'Comments', display: 'OBS', filterOptions: [], width: 5 },
        { name: 'Comments2', display: 'OBS2', filterOptions: [], width: 5 },
    ];

}

SdOrdersController.$inject = ['TranslationService', 'StoreService'];

seedWebApp.component('sdOrders', {
    controller: SdOrdersController,
    bindings: {
        loading: '<',
        contactId: '<',
        orders: '<',
    },
    templateUrl: '/SPA/components/sd-orders.html'
});